module.exports = __webpack_public_path__ + "img/fdml.affee6d0.png";